import { render, staticRenderFns } from "./Concat.vue?vue&type=template&id=d9d80c40&scoped=true&"
import script from "./Concat.vue?vue&type=script&lang=js&"
export * from "./Concat.vue?vue&type=script&lang=js&"
import style0 from "./Concat.vue?vue&type=style&index=0&id=d9d80c40&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9d80c40",
  null
  
)

export default component.exports